import { MathJaxObject } from "mathjax-full/js/components/startup";
import App from "../../app";
import SwipeHandler from "../../lib/swipe";
import { AttemptId, ItemId, ProductId, QuizId } from "../../model/datasource";
import { ContentItem, ItemType } from "../../model/datasource/item";
import { ItemFrontend } from "../frontend";
import { DisplayItemFrontend } from "../frontend/displayitem";
import { AnswerType } from "../../lib/userdata";

export abstract class ItemView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	frontend: ItemFrontend<I>;
	swipe: SwipeHandler;

	protected constructor(frontend?: ItemFrontend<I>) {
		this.frontend = frontend;
		this.swipe = new SwipeHandler();
	}

	abstract init(app: App<P, A, Z, I>): void

	abstract rebindKeyboard(app: App<P, A, Z, I>, type: ItemType): void
	abstract displayLoading(status: "done" | "loading" | "error"): void
	abstract displayFinishing(status: "ready" | "loading" | "error"): void
	abstract displaySelectedAnswer(type: ItemType, answer: AnswerType | undefined) : void
	protected abstract displayItemClass(content: ContentItem<I>): DisplayItemFrontend<I>
	abstract toggleContexts(contexts: string[]): void
	abstract displayFontSize(fontSize: number): void
	abstract displayResults(url: string): void
	abstract displayPauseModal(jQuery: JQueryStatic, show: boolean): void

	displayItemContent(content: ContentItem<I>, bindTarget: EventTarget): void {
		const itemClass = this.displayItemClass(content);
		itemClass.hideItemTypes();
		itemClass.displayItemContent(content, bindTarget);
	}

	abstract displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: AnswerType): void
	abstract displayItemSameContext(content: ContentItem<I>, sameContexts: ContentItem<I>["contexts"]): void
	abstract displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void
	abstract displayItemAlerts(content: ContentItem<I>): void
}

export class NullItemView<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends ItemView<P, A, Z, I> {
	frontend: ItemFrontend<I>;

	constructor(frontend?: ItemFrontend<I>) {
		super(frontend);
	}

	init(app: App<P, A, Z, I>): void { }

	rebindKeyboard(app: App<P, A, Z, I>, type: string): void {
		throw new Error("Method not implemented.");
	}

	displayLoading(status: "done" | "loading" | "error"): void {
		throw new Error("Method not implemented.");
	}

	displayFinishing(status: "ready" | "loading" | "error"): void {
		throw new Error("Method not implemented.");
	}

	displaySelectedAnswer(answer: AnswerType): void {
		throw new Error("Method not implemented.");
	}

	displayItemClass(content: ContentItem<I>): DisplayItemFrontend<I> {
		throw new Error("Method not implemented.");
	}

	displayItem(mathjax: MathJaxObject, content: ContentItem<I>, bindTarget: EventTarget, answer: string, sameContext: boolean): void {
		throw new Error("Method not implemented.");
	}

	toggleContexts(contexts: string[]): void {
		throw new Error("Method not implemented.");
	}

	displayFontSize(fontSize: number): void {
		throw new Error("Method not implemented.");
	}

	displayResults(url: string): void {
		throw new Error("Method not implemented.");
	}

	displayPauseModal(jQuery: JQueryStatic, show: boolean): void {
		throw new Error("Method not implemented.");
	}

	displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: AnswerType | undefined): void {
		throw new Error("Method not implemented.");
	}

	displayItemSameContext(content: ContentItem<I>, sameContexts: ContentItem<I>["contexts"]): void {
		throw new Error("Method not implemented.");
	}

	displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void {
		throw new Error("Method not implemented.");
	}

	displayItemAlerts(content: ContentItem<I>) : void {
		throw new Error("Method not implemented.");
	}
}
